let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

(function($) {
  $(document).ready(function($) {

    var loaderInterval;
    var totalFinished = 0;  

    if ($('.loader').length){

      loaderInterval = setInterval(function() {

        $('#loader-coords').find('span').each(function() {

          var $this = $(this);
          var double = false;

          if ($this.data('type') == 'double') {

            updateLoader($this, 99, false);

          } else {

            updateLoader($this, 9, false);

          }
          
        });

      }, 100);


      $(window).on('load', function() {

        clearInterval(loaderInterval);
        $('#loader-coords').find('span').each(function() {

          if ($(this).data('type') == 'double') {
            $(this).text('00');
          } else {
            $(this).text('0');
          }

        });

        loaderInterval = setInterval(function() {

          if ($('#loader-coords').find('span').length == $('#loader-coords').find('span.finished').length) {

            clearInterval(loaderInterval);

            var timeout = 500;

            if (window.viewport().width <= 880) {timeout = 0}

            $('.loader').addClass('finished');

            setTimeout(function(){

              $('.loader').fadeOut(500);

              setTimeout(function() {

                enableMouseHover();

              }, 500);

            }, timeout);

          } else {

            $('#loader-coords').find('span').each(function() {

            var $this = $(this);

              updateLoader($this, $this.data('total'), true);
            
            });

          }

        }, 50);

      });

    }

    function updateLoader(number, total, stop) {

      var num = number.text();

      num++;
      if (total > 10) {

        if (num >= total){
          if (stop) {
            num = total;
            number.addClass('finished');
          } else {
            num = 0
          }
        }
        if (num < 10) {
          num = '0' + num;
        }

      } else {

        if (num >= total){
          if (stop) {
            num = total;
            number.addClass('finished');
          } else {
            num = 0
          }
        }

      }
      number.text(num);

    }

    if ($('.hp-hero__video').length) {

      $('.hp-hero__video')[0].addEventListener('ended', function () {
        this.play();

        $('.hp-quiz__scroll:not(.animate)').addClass('animate');

      })

    }

    if ($('.video-modal__main video').length) {

      $('.video-modal__main video')[0].addEventListener('ended', function () {
       
        $('.video-modal').fadeOut();
        $("html, body").animate({ scrollTop: $('.hp-quiz').offset().top - 7 }, 600);

      })

    }

    $('#desktop-share').on('click', function(e){

      e.preventDefault();

      var $this = $(this);
      var $temp = $("<input>");
      var toCopy = window.location.href;


      $("body").append($temp);
      $temp.val(toCopy).select();
      document.execCommand("copy");
      $temp.remove();

      $this.addClass('active');
      setTimeout(function () {
        $this.removeClass('active');
      }, 2000);

    });

    $('#mobile-share').on('click', function(e){

      e.preventDefault();

      try {
        navigator.share({
          title: document.title,
          url: location.href,
        });
      } catch (err) {
        console.error(`${err.name}: ${err.message}`);
      }

    });

    if ($('.hp-quiz').length) {

      $(window).on('scroll load', function() {

        var h = (window.viewport().height - $('.hp-hero').outerHeight(true)) + $(window).scrollTop();
        var max = $('.hp-quiz').outerHeight();

        if (h >= max) {

          $('#hp-quiz-images').height(max);

        } else {

          $('#hp-quiz-images').height(h);

        }


      });

    }

    function enableMouseHover() {

      if (window.viewport().width > 880) {

        $('body').on('mousemove', function(event) {

          if ($('.hp-quiz').length) {

            var x = getMouseX(event);
            var slice = (window.viewport().width - 96) / 6;
            var section = Math.ceil((x - 48) / slice)
            var coords;

            if (section < 1) {section = 1}
            if (section > 6) {section = 6}

            $('#hp-quiz-coords').text($('#hp-answer-' + section).data('coords'));
            $('#hp-image-' + section).addClass('active').siblings().removeClass('active');

          }

        });

      }

    }

    $('[data-hover]').hover(function() {

      $('body').addClass('hp-hover');

    }, function() {

      $('body').removeClass('hp-hover');

    });

    function getMouseX(event) {

      var eventDoc, doc, body;

      event = event || window.event; // IE-ism

      // If pageX/Y aren't available and clientX/Y are,
      // calculate pageX/Y - logic taken from jQuery.
      // (This is to support old IE)
      if (event.pageX == null && event.clientX != null) {
          eventDoc = (event.target && event.target.ownerDocument) || document;
          doc = eventDoc.documentElement;
          body = eventDoc.body;

          event.pageX = event.clientX +
            (doc && doc.scrollLeft || body && body.scrollLeft || 0) -
            (doc && doc.clientLeft || body && body.clientLeft || 0);
          event.pageY = event.clientY +
            (doc && doc.scrollTop  || body && body.scrollTop  || 0) -
            (doc && doc.clientTop  || body && body.clientTop  || 0 );
      }

      return event.pageX;

    }

    $('.hp-quiz__scroll, .hp-quiz__text').on('click', function() {

      var diff = 10;

      if (window.viewport().width <= 880) {diff = 7}

      $("html, body").animate({ scrollTop: $('.hp-quiz').offset().top - diff }, 600);

    });

    $('.hp-quiz__answer').on('click', function() {

      $(this).toggleClass('active').siblings().removeClass('active');

      if ($('.hp-quiz__answer.active').length) {

        $('.hp-quiz__cta').addClass('active');

      } else {

        $('.hp-quiz__cta').removeClass('active');

      }

      $('.hp-quiz__cta').attr("href", $('.hp-quiz__cta').data('lang')+'/quiz?type='+encodeURIComponent($(this).data('type')));


    });

    $('#menu-trigger').on('click', function() {

      $(this).toggleClass('active');
      $('.mobile-menu').fadeToggle();
      $('body').toggleClass('menu-open')

    });

    $('#menu-quiz-trigger').on('click', function(e) {

      if ($('.hp-quiz').length) {

        e.preventDefault();
        $('#menu-trigger').click();
        $("html, body").animate({ scrollTop: $('.hp-quiz').offset().top - 7 }, 600);

      }

    });

    $('#rv-slider').slick({

      variableWidth: true,
      infinite: false,
      rows: 0,
      prevArrow: '<button class="slick-prev"><svg class="full-arrow"><use xlink:href="#full-arrow"></use></svg></button>',
      nextArrow: '<button class="slick-next"><svg class="full-arrow"><use xlink:href="#full-arrow"></use></svg></button>',
      appendArrows: $('#rv-slider-buttons'),

    });

    $('#results-banner-close').on('click', function() {

      $('.results-banner').fadeOut();

    });

    if ($('.results-banner').length) {

      setTimeout(function(){

        $('.results-banner').fadeOut();

      }, 5000);

    }


    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    var player = false;

    $('.about-video-trigger, #hp-video-trigger').on('click', function() {

      $('.video-modal').fadeIn(); // .find('video')[0].play();

      if(!player) {
        var video_id = $('#youtube-player').data('video');
        player = new YT.Player('youtube-player', {
          height: '390',
          width: '640',
          videoId: video_id,
          playerVars: {
            'playsinline': 1
          },
          events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
          }
        });
      }else{
        player.playVideo();
      }

    });

    function onPlayerReady(event) {
      event.target.playVideo();
    }

    function onPlayerStateChange(event) {
      if (event.data == YT.PlayerState.ENDED) {
        $('.video-modal').fadeOut();
        if ($('.hp-quiz').length) {
          $("html, body").animate({ scrollTop: $('.hp-quiz').offset().top - 7 }, 600);
        }
        
      }
    }
    function stopVideo() {
      player.stopVideo();
    }

    $('#video-modal-close, .video-modal').on('click', function() {

      $('.video-modal').fadeOut();
      player.stopVideo();

    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27){
        $('#video-modal-close').click();
      }
    });

    $('.about-header-link').on('click', function() {

      var id = $(this).data('id');

      $("html, body").animate({ 
        scrollTop: $('#about-header-' + id).offset().top - 10 
      }, 600);

    });



    $("form#subscribe").submit(function (event) {
      event.preventDefault();

      $('.subscribe-message').html('').removeClass('success error');
      var data = {
        action: 'gorv_cm_submit',
        nonce: gorving_quiz_main.nonce,
        email: $("#email-subscribe").val(),
      };

      $.post(gorving_quiz_main.ajax, data, function(response) {

        if(response.success)
          $('.subscribe-message').html('Subscribed!').addClass('success');
        else
          $('.subscribe-message').html(response.data.message).addClass('error')

      });


    });




  });
})(jQuery);
